<!-- MODAL HEADER-->
<div style="overflow: hidden;">
  <div class="row modal-bar">

    <div class="col-sm-6">
      <h5 class="modal-title">{{ 'RELATIONS.MANUAL-IDENTIFICATION-DIALOG.TITLE' | translate }}</h5>
    </div>

    <div class="col-sm-6">
      <div class="modal-actions">
        <div class="modal-close">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
        </div>
      </div>
    </div>
  </div>

  <form class="form-content">
    <div class="section-wrapper">
      <div class="form-layout">
        <div class="row">
          <div class="col-lg-3">

            @if (startedIdentification) {
              <div >
                <div>
                  @if (isVerified) {
                    <div class="alert alert-success text-format">
                      <span>{{ getStatusText(identificationStatus.Status) | translate }}</span>
                    </div>
                  }
                  @if (!isVerified && !isRejected()) {
                    <div class="alert alert-warning text-format">
                      <span>{{ getStatusText(identificationStatus.Status) | translate }}</span>
                    </div>
                  }
                  @if (!isVerified && isRejected()) {
                    <div class="alert alert-danger text-format">
                      <span>{{ getStatusText(identificationStatus.Status) | translate }}</span>
                    </div>
                  }
                </div>
                <br>
                  <div class="row">
                    <div class="col-lg-3">
                      <span>{{ 'RELATIONS.MANUAL-IDENTIFICATION-DIALOG.CUSTOMER' | translate }}</span>
                    </div>
                    <div class="col-lg-9">
                      <span><b><t4-customer-identification-control [isIbaActive]="isIbaActive" [showCustomerNumber]="true" [customer]="constructCustomerIdentificationModel()"></t4-customer-identification-control></b></span>
                    </div>
                  </div>
                  <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">
                  <div class="row">
                    <div class="col-lg-3">
                      <span>{{ 'RELATIONS.MANUAL-IDENTIFICATION-DIALOG.METHOD' | translate }}</span>
                    </div>
                    <div class="col-lg-9">
                      <b>{{ identificationStatus.CustomerIdentificationType }}</b>
                    </div>
                  </div>
                  <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">
                  <div class="row">
                    <div class="col-lg-3">
                      <span>{{ 'RELATIONS.MANUAL-IDENTIFICATION-DIALOG.BY' | translate }}</span>
                    </div>
                    <div class="col-lg-9">
                      <b>{{ identificationStatus.UserCalculatedName }}</b>
                    </div>
                  </div>
                  <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">
                  <div class="row">
                    <div class="col-lg-3">
                      <span>{{ 'RELATIONS.MANUAL-IDENTIFICATION-DIALOG.REASON' | translate }}</span>
                    </div>
                    <div class="col-lg-9">
                      <b>{{ identificationStatus.Reason ? identificationStatus.Reason : '-' }}</b>
                    </div>
                  </div>
                </div>
              } @else {
                <span>{{ 'RELATIONS.MANUAL-IDENTIFICATION-DIALOG.IDENTIFICATION-NOT-STARTED' | translate }}</span>
              }


              <hr style="margin-top: 0.5rem; margin-bottom: 0.5rem;">

              @if (!isVerified && !pendingActionOfEmployee && mode !== identifcationModeEnum.App) {
                <div>
                  <button (click)="verifyCustomer()"  class="btn btn-block btn-success bd-0">
                    <i class="far fa-check-square"></i><span>{{ 'GENERIC.BUTTON.IDENTIFICATION.IDENTIFY' | translate }}</span>
                  </button>
                </div>
              }
              <br>
                @if (!isVerified && !pendingActionOfEmployee && mode.includes(identifcationModeEnum.App)) {
                  <div>
                    <button (click)="verifyAppCustomer()"  class="btn btn-block btn-success bd-0">
                      <i class="far fa-check-square"></i><span>{{ 'GENERIC.BUTTON.IDENTIFICATION.APP-IDENTIFY' | translate }}</span>
                    </button>
                  </div>
                }
                <br>
                  <div>
                    <button (click)="rejectCustomer()" class="btn btn-block btn-danger bd-0">
                      <i class="fas fa-redo"></i><span>{{ 'GENERIC.BUTTON.IDENTIFICATION.RESTART' | translate }}</span>
                    </button>
                  </div>

                </div>
                <div class="col-lg-9">
                  <t4-list-view #listVw [options]="listOptions" (onDataRequest)="OnDataRequest($event)">

                    <ng-container *t4ListItem="let item">

                      <td>{{ item.Created | localDate }}</td>
                      <td>{{ item.Created | localTime }}</td>
                      <td><a (click)="navigateToIdVerification(item)">{{ getStatusText(item.Status) | translate }}</a></td>
                      <td>{{ item.UserCalculatedName }}</td>
                      <td>{{ item.CustomerIdentificationType }}</td>
                      <td style="white-space: normal;">{{ item.Reason }}</td>
                      <td>{{ item.ExpirationDate | date:'dd-MM-yyyy' | replaceOnEmpty }}</td>

                    </ng-container>

                  </t4-list-view>
                </div>
              </div>
            </div><!-- form-layout -->
          </div>
        </form>
      </div>